import React, { useState, useEffect, useRef, useCallback } from "react";
import Image from "../fragments/Image";

const PageIntroduction = ({ block }) => {

    if (!block) return null;

    return (
        <div className="c-page__block c-page__block--introduction">
            <div className="c-introduction">
                <div className="l-grid">
                    <div className="l-grid__col">
                        {block.introduction &&
                            <div className="c-introduction__text scope-large-text" dangerouslySetInnerHTML={{ __html: `<p>${block.introduction}</p>` }}></div>
                        }
                    </div>
                    <div className="l-grid__col l-grid__col--m-8-12 l-grid__col--l-6-12">
                        {block.image_src &&
                            <Image 
                                width={block.image_width}
                                height={block.image_height}
                                src={block.image_src} 
                                alt={''}
                            />
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PageIntroduction;
